import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './LanguageToggle.css';

const LanguageToggle = () => {
  const { language, changeLanguage } = useLanguage();

  const toggleLanguage = () => {
    changeLanguage(language === 'en' ? 'ru' : 'en');
  };

  // Labelled in the language you would switch TO, so it reads right either way.
  const switchLabel = language === 'en' ? 'Переключить на русский' : 'Switch to English';

  return (
    <button 
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label={switchLabel}
      title={switchLabel}
    >
      <span className="lang-text">{language === 'en' ? 'РУ' : 'EN'}</span>
    </button>
  );
};

export default LanguageToggle;
